import { render, staticRenderFns } from "./ListPromotionRow.vue?vue&type=template&id=422e3ea4&scoped=true"
import script from "./ListPromotionRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListPromotionRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListPromotionRow.vue?vue&type=style&index=0&id=422e3ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e3ea4",
  null
  
)

export default component.exports